import {React} from '@api';
import {StyleSheet, Text, View} from "@react-pdf/renderer";
import {useStores} from '@modules'
import {styled} from '@pdf'

const WatermarkView = styled.View`
  display: flex;
  flex-direction:column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  font-family: Arial Bold;
`

const Company = styled.Text`
  font-size: ${p => p.zoom * 18}px;
  letter-spacing: -0.5px;
`

const CompanyLocation = styled.Text`
  font-size: ${p => p.zoom * 15}px;
  margin-top:4px;
  letter-spacing: 3px;
`

export const Watermark = ({zoom}: { zoom?: number }) => {
  const {workspaces: {deploymentConfig: {customer}}} = useStores()
  return <WatermarkView>
    <Company zoom={zoom}>{customer?.name}</Company>
    <CompanyLocation zoom={zoom}>{customer?.location}</CompanyLocation>
  </WatermarkView>
}

Watermark.defaultProps = {zoom: 1}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/watermark.tsx